'use strict';

var mcb = mcb || {};
mcb.url = mcb.url || {};

mcb.url.utils = mcb.url.utils || new function () {
    this.init = function() {}
    this.navigateToSticky = function(url, queryParams) {
        const createQueryString = (data) => {
            if (data === undefined || data === null)
                return null;

            var qs = new URLSearchParams();
            Object.keys(data).forEach(key => {
                var val = data[key];
                if (!val) {
                    return;
                }
                if (val !== null && Array.isArray(val)) {
                    val.forEach(value => {
                        if (value) {
                            qs.append(key, value);
                        }
                    });
                    return;
                }

                qs.append(key, val);
            });

            return qs.toString();
        };

        var qs = createQueryString(queryParams);
        if (qs) {
            window.location = url + "?" + qs;
        } else {
            window.location = url + window.location.search;
        }
    }
}();